import autobind from 'autobind-decorator';
import * as React from 'react';
import { H5, Switcher, Text } from '@shared/ui-components';
import { BillingPeriodUnit } from '../../../enums/billing-period-unit';

import { Styled } from './styled';

interface Props {
  billingPeriod: BillingPeriodUnit;
  setBillingPeriod: (billingPeriod: BillingPeriodUnit) => void;
}

export class SubscriptionListingHead extends React.Component<Props> {
  public render(): React.ReactNode {
    const { billingPeriod } = this.props;

    return (
      <Styled.Container>
        <H5>Pricing</H5>
        <Styled.Period>
          <Text fontSize={12} color='additionalFont'>Annually</Text>
          <Styled.Discount>
            <Text fontSize={12}>Save 10%</Text>
          </Styled.Discount>
          <Switcher
            checked={billingPeriod === 'Month'}
            onChange={this.changePeriod}
            size='s'
          />
          <Text fontSize={12} color='additionalFont'>Monthly</Text>
        </Styled.Period>
      </Styled.Container>
    );
  }

  @autobind
  private changePeriod(): void {
    const billingPeriod = this.props.billingPeriod === BillingPeriodUnit.Month
      ? BillingPeriodUnit.Year
      : BillingPeriodUnit.Month;

    this.props.setBillingPeriod(billingPeriod);
  }
}
